import { render, staticRenderFns } from "./CategoryTitle.vue?vue&type=template&id=499b967f&"
import script from "./CategoryTitle.vue?vue&type=script&lang=ts&"
export * from "./CategoryTitle.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports